import store from '@/store';

// Получение всех данных при загрузке графика аптеки
export const getPharmacies = async () => {
  store.commit('user/setLoader', true)
  store.commit('data/clearOpenedCreateShift')
  await store.dispatch("data/getPharmacies");
  await store.dispatch("data/getExternalUsers");
  await store.dispatch('data/getFondWorkTime')
  await store.dispatch("data/getHolidays");
  await store.dispatch("data/getShiftsExistence");
  await store.dispatch("data/getTimeScheduleDetails");
  await store.dispatch("data/getPastTimeScheduleDetails");
  await store.dispatch('data/getTimeSchedule')
  await store.dispatch('data/getPharmSchedule')
  await store.dispatch('data/getAdminShift', true)
  await store.dispatch('data/getFondWorkTimeHuman')
  store.commit('user/setLoader', false)
}